<script>
import VehicleInfoComponent from '@/components/VehicleInfoComponent'
import RightLayout from '@/router/layouts/rightLayout'
export default {
  components: { VehicleInfoComponent, RightLayout }
}
</script>

<template>
<right-layout>
  <vehicle-info-component
  :title="'車両を編集'"
  :btnName="'保存'"
  :func="'editor'"
  ></vehicle-info-component>
</right-layout>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/router/views/VehicleEditor.vue